import React from "react";
import { cn } from "@/lib/utils";

export function TBodyCell({
  children,
  isLastCell,
  className,
}: {
  children: React.ReactNode;
  isLastCell?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        `p-4 py-0 pl-4 text-left text-sm text-foreground ${
          isLastCell ? "flex justify-end" : ""
        }`,
        className,
      )}
      role="none"
      aria-label={typeof children === "string" ? children : undefined}
    >
      {children}
    </div>
  );
}
